import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { NzTimePickerModule, NZ_I18N, pt_BR } from 'ng-zorro-antd';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';

import { EditFacModalModule } from '../shared/components/edit-fac-modal/edit-fac-modal.module';
import { ReportsComponent } from './reports.component';
import { DistributionServiceComponent } from './components/distributionService/distribution-service.component';
import { DistributionBrokerComponent } from './components/distributionBroker/distribution-broker.component';
import { AvatarComponent } from './components/AvatarComponent/avatar.component';

@NgModule({
  declarations: [
    DistributionServiceComponent,
    DistributionBrokerComponent,
    ReportsComponent,
    AvatarComponent,
  ],
  imports: [
    CoreModule,
    SharedModule,
    RouterModule,
    NzTimePickerModule,
    NzDatePickerModule,
    EditFacModalModule
  ],
  exports: [
    DistributionServiceComponent,
    DistributionBrokerComponent,
    ReportsComponent,
    ReportsComponent,
    AvatarComponent,
  ],
  providers: [
    { provide: NZ_I18N, useValue: pt_BR }
  ],
})
export class ReportsModule {

}
